import React from 'react';
import '../styles/FloodZoneAnalysis.css';
import { Badge } from './';

function FloodZoneAnalysis(props) {
    const { floodZoneAnalysis, darkMode = false } = props;

    // Early return if no flood zone analysis data
    if (!floodZoneAnalysis) {
        return null;
    }

    const textColorClass = darkMode ? 'colour-white' : 'colour-primary';
    const containerClass = darkMode ? 'bg-colour-dark-mode' : 'bg-colour-white';

    // Extract flood zone data
    const {
        floodZones = [],
        analysis = '',
        matchCount = 0,
        nonMatchCount = 0,
        totalComps = 0
    } = floodZoneAnalysis;

    // Format flood zones for display (e.g., ["X", "D"] -> "X and D")
    const formatFloodZones = () => {
        if (!floodZones || floodZones.length === 0) return '';
        if (floodZones.length === 1) return floodZones[0];
        if (floodZones.length === 2) return `${floodZones[0]} and ${floodZones[1]}`;
        return floodZones.slice(0, -1).join(', ') + ', and ' + floodZones[floodZones.length - 1];
    };

    // Generate recommendation text from flood zones
    const getRecommendationText = () => {
        const formattedZones = formatFloodZones();
        if (!formattedZones) return '';
        return `Prioritize comps in flood zones ${formattedZones}.`;
    };

    const recommendationText = getRecommendationText();

    return (
        <div className={`flood-zone-analysis-container ${containerClass}`}>
            {/* Header Section */}
            <div className="flood-zone-analysis-header-section">
                <h3 className={`heading-small-bold ${textColorClass}`}>
                    Flood zone analysis
                </h3>
                {analysis && (
                    <p className={`body-regular ${textColorClass}`}>
                        {analysis.replace(/\*\*/g, '')}
                    </p>
                )}
            </div>

            {/* Review Section */}
            {(recommendationText || totalComps > 0) && (
                <div className="flood-zone-analysis-review-section">
                    {recommendationText && (
                        <p className={`body-bold ${textColorClass}`}>
                            {recommendationText}
                        </p>
                    )}
                    {totalComps > 0 && (
                        <div className="flood-zone-analysis-review-stats">
                            <div className="flood-zone-analysis-review-stats-row">
                                <div className="flood-zone-analysis-review-row">
                                    <Badge
                                        bgColour="bg-colour-gray-02"
                                        statusDot={false}
                                        statusDotColour={null}
                                        text={totalComps.toString()}
                                        textClass={`body-regular colour-primary`}
                                        icon={null}
                                        tooltip={false}
                                        tooltipBody={null}
                                        tooltipPosition={null}
                                        iconLeft={null}
                                    />
                                    <span className={`body-regular ${textColorClass}`}>
                                        comps reviewed.
                                    </span>
                                </div>
                                <div className="flood-zone-analysis-review-row">
                                    <Badge
                                        bgColour="bg-colour-aqua-01"
                                        statusDot={false}
                                        statusDotColour={null}
                                        text={matchCount.toString()}
                                        textClass={`body-regular colour-primary`}
                                        icon={null}
                                        tooltip={false}
                                        tooltipBody={null}
                                        tooltipPosition={null}
                                        iconLeft={null}
                                    />
                                    <span className={`body-regular ${textColorClass}`}>
                                        approved flood-zone matches.
                                    </span>
                                </div>
                            </div>
                            <div className="flood-zone-analysis-review-row">
                                <Badge
                                    bgColour="bg-colour-red-01"
                                    statusDot={false}
                                    statusDotColour={null}
                                    text={nonMatchCount.toString()}
                                    textClass={`body-regular colour-primary`}
                                    icon={null}
                                    tooltip={false}
                                    tooltipBody={null}
                                    tooltipPosition={null}
                                    iconLeft={null}
                                />
                                <span className={`body-regular ${textColorClass}`}>
                                    comps flagged for being in restricted flood zones.
                                </span>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default FloodZoneAnalysis;

